import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-auth-shell',
  standalone: true,
  imports: [CommonModule, RouterOutlet],
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
})
export class AuthShellComponent implements OnInit, OnDestroy {
  backgroundUrl = 3;

  isInterval: ReturnType<typeof setInterval> | null = null;

  ngOnInit(): void {
    this.getBackgroundImage();
  }

  ngOnDestroy(): void {
    if (this.isInterval !== null) {
      clearInterval(this.isInterval);
      this.isInterval = null;
    }
  }

  getBackgroundImage() {
    this.isInterval = setInterval(() => {
      this.backgroundUrl = Math.floor(Math.random() * 6) + 1;
    }, 8000);
  }
}